import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash.isnil';
import PhonemicAwarenessAssessmentRow from './PhonemicAwarenessAssessmentRow';
import './PhonemicAwarenessProbeDetails.scss';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const reformatPsfItemLevelDetails = itemLevelDetails => {
    return isNil(itemLevelDetails)
        ? {
              itemId: -1,
              selfCorrectedPhonemes: [],
              incorrectPhonemes: [],
              segments: [],
              score: 0,
              maxScore: 0,
          }
        : {
              itemId: itemLevelDetails.item_idx,
              selfCorrectedPhonemes: itemLevelDetails.self_corrected_phonemes,
              incorrectPhonemes: itemLevelDetails.incorrect_phonemes,
              segments: itemLevelDetails.segments,
              score: itemLevelDetails.score,
              maxScore: itemLevelDetails.max_score,
          };
};

const PhonemicAwarenessProbeDetails = ({ result, content, selfCorrectedMark }) => (
    <div className="psf-container">
        <div className="container">
            {content.items.map(line => {
                const itemLevelDetails = result.itemLevelDetails.word_events.find(
                    item => item.item_idx === line.item_idx,
                );
                return (
                    <PhonemicAwarenessAssessmentRow
                        key={generateReactKey(line.item_idx)}
                        line={line}
                        itemLevelDetails={reformatPsfItemLevelDetails(itemLevelDetails)}
                        selfCorrectedMark={selfCorrectedMark}
                    />
                );
            })}
        </div>
    </div>
);

PhonemicAwarenessProbeDetails.defaultProps = {
    selfCorrectedMark: 'sc',
};

PhonemicAwarenessProbeDetails.propTypes = {
    result: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
    selfCorrectedMark: PropTypes.string,
};

export default PhonemicAwarenessProbeDetails;
